define('view/form/person.finder.content.view',['require','exports','module','underscore','./base.finder.content.view','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _                     = require('underscore'),
      BaseFinderContentView = require('./base.finder.content.view'),
      Formatter             = require('fukit').Formatter;

  var PersonFinderPreviewAnswerInsideTableEmptyView = BaseFinderContentView.PreviewAnswerInsideTableEmptyView.extend({
    internalViewOptions: BaseFinderContentView.PreviewAnswerInsideTableEmptyView.extendInternalViewOptions({
      emptyTextView: {
        text: 'No person selected.',
      },
      findButtonView: {
        text: 'Find person.',
      },
    }),
  });

  var PersonFinderPreviewAnswerInsideTableView = BaseFinderContentView.PreviewAnswerInsideTableView.extend({
    options: _.extend({}, BaseFinderContentView.PreviewAnswerInsideTableView.prototype.options, {
      type: 'Person',
      modalHeaderText: 'Person Finder',
      finderEmptyView: PersonFinderPreviewAnswerInsideTableEmptyView,
    }),

    internalViewOptions: BaseFinderContentView.PreviewAnswerInsideTableView.extendInternalViewOptions({
      finderTableView: function() {
        return {
          columns: [
            {
              data: '',
              formatter: function(value, model, column, index) {
                return model.get('firstName') + ' ' + model.get('lastName');
              },
            },
          ],
        };
      },
    }),
  });

  var PersonFinderPreviewAnswerView = BaseFinderContentView.PreviewAnswerView.extend({
    options: _.extend({}, BaseFinderContentView.PreviewAnswerView.prototype.options, {
      type: 'Person',
      modalHeaderText: 'Person Finder',
    }),

    internalViewOptions: BaseFinderContentView.PreviewAnswerView.extendInternalViewOptions({
      finderTableView: function() {
        return {
          columns: [
            // COI-2142: new person finder at coi-service-v2 instead of deprecated datagator
            { text: 'First Name', data: 'firstName', formatter: Formatter.empty() },
            { text: 'Last Name', data: 'lastName', formatter: Formatter.empty() },
            //{ text: 'Name', data: 'name', formatter: Formatter.empty() },
            { text: 'Email', data: 'email', formatter: Formatter.empty() },
            { text: 'Phone', data: 'phone', formatter: Formatter.empty() },
          ],
          emptyText: 'No person has been selected.',
        };
      },
      addButtonView: function() {
        return {
          text: 'Find Person',
        };
      },
    }),
  });

  var PersonFinderContentView = BaseFinderContentView.extend({
    internalViewOptions: BaseFinderContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PersonFinderPreviewAnswerView,
        };
      },
    }),
  });

  PersonFinderContentView.PreviewAnswerInsideTableView = PersonFinderPreviewAnswerInsideTableView;
  PersonFinderContentView.PreviewAnswerInsideTableEmptyView = PersonFinderPreviewAnswerInsideTableEmptyView;
  PersonFinderContentView.PreviewAnswerView = PersonFinderPreviewAnswerView;

  module.exports = PersonFinderContentView;
});

